
/*
 *
 * Date: 2025
 * Description: Main context initialization.
 * Author: Philippe Leroux @SKITSC
 *
 */


//Modules
import { createContext } from "react";
import { NavigateFunction } from "react-router-dom";

//Interfaces
import { i_theme_context , i_main_context } from "../interfaces/context.interface";

//Constants
import { default_user } from "../utils/constant";

export const defaultContext : i_main_context = {
    authenticated : false,
    user : default_user,
    redirect_url : '',
    setCurrentAuth : () => {},
    setCurrentUser: () => {},
    setCurrentRedirectUrl : () => {},
    HandleLogin : () => {},
    HandleLogout : (Navigator : NavigateFunction) => {},
}

export const defaultTheme : i_theme_context = {
    mode : 'Light',
    primary : '#B71F26',
    secondary : '#F50057',
    hover : '#121212',
    selected : '#B71F26',
    setCurrentColor : () => {},
    setCurrentTheme : () => {}
}

export const MainContext =  createContext<i_main_context>(defaultContext);
export const ThemeContext = createContext<i_theme_context>(defaultTheme);